import React from 'react';
import { StyleSheet } from 'react-native';

import { IconTitle } from '@components/Typography';

export type FormSectionTitleProps = {
  /** Icon shown beside the section title. */
  icon: React.ComponentProps<typeof IconTitle>['icon'];
  /** Visible section title. */
  title: string;
};

export function FormSectionTitle({ icon, title }: FormSectionTitleProps) {
  return <IconTitle icon={icon} text={title} style={styles.container} />;
}

const styles = StyleSheet.create({
  container: { marginTop: 5 },
});
